import Vue from 'vue'
import VueRouter from 'vue-router'
import PageArticle from '@/views/article/src/view/article/Article'

import utils from '../views/article/src/utils/index'

Vue.use(VueRouter)

const PageHome = resolve => require(['@/views/home/home.vue'], resolve)
const PageList = resolve => require(['@/views/list/list.vue'], resolve)
const PageGame = resolve => require(['@/views/game/game.vue'], resolve)
const PageNext = resolve => require(['@/views/next/next.vue'], resolve)

const routes = [
  { path: '/', name: 'home', component: PageHome },
  { name: 'article', path: '/article/:id(.*)', component: PageArticle, meta: { title: '' } },
  { name: 'list', path: '/list', component: PageList },
  { name: 'game', path: '/game', component: PageGame },
  { name: 'next', path: '/next', component: PageNext }
]

const router = new VueRouter({
  mode: 'history',
  base: '/zones/google/cloud',
  routes
})

// 正式上线前，只允许进入 Landing Page 页面
router.beforeEach((to, from, next) => {
  utils.initWxConfig().then(() => {
    next()
    // const url = window.location.href
    // let query = {
    //   targetUrl: url
    // }

    // let guideCache = utils.storage.get('guide')
    // if (/^articleReview/.test(to.name)) {
    //   next()
    // } else if (!guideCache.finishGuide && !/^guide/.test(to.name)) {
    //   next({ path: '/guide', query: to.name === 'article' ? query : {} })
    // } else {
    //   next()
    // }
  }).catch(() => {
    next()
  })
})

router.afterEach((to, from) => {
  if (window.ga) {
    utils.GA('set', 'page', to.fullPath)
    utils.GA('send', 'pageview')
    // window.gtag('config', 'UA-103082599-11', { 'page_path': to.fullPath })
    // window.gtag('config', 'UA-160408832-1', { 'page_path': to.fullPath })
    // gtag('event',  to.fullPath, { 'send_to': 'agency' });
  }

  utils.shareWeixin()
})

export default router
